import { Icon } from "./Icon.tsx";

/** A chain link — ControlRuleBuilder.tsx's premise-side toggle for "compare
 * to another element's attribute", against HashIcon's "compare to a fixed
 * value". */
export function LinkIcon() {
  return (
    <Icon>
      <path d="M10 13a5 5 0 0 0 7.07 0l1.9-1.9a5 5 0 1 0-7.07-7.07L10.5 5.5" />
      <path d="M14 11a5 5 0 0 0-7.07 0l-1.9 1.9a5 5 0 1 0 7.07 7.07L13.5 18.5" />
    </Icon>
  );
}
